import { Field, useSlotRecipe } from "@chakra-ui/react";
import type { ReactNode } from "react";

export interface FormFieldProps {
  label?: ReactNode;
  helper?: ReactNode;
  error?: ReactNode;
  children: ReactNode;
}

export const FormField = ({ label, helper, error, children }: FormFieldProps) => {
  const recipe = useSlotRecipe({ key: "formField" });
  const styles = recipe({} as Parameters<typeof recipe>[0]);

  return (
    <Field.Root invalid={!!error} css={styles.root}>
      {label && <Field.Label css={styles.label}>{label}</Field.Label>}
      {children}
      {helper && !error && (
        <Field.HelperText css={styles.helper}>{helper}</Field.HelperText>
      )}
      {error && <Field.ErrorText css={styles.error}>{error}</Field.ErrorText>}
    </Field.Root>
  );
};
